import React from 'react'
import { View, TouchableOpacity, Linking, Platform } from 'react-native'
import PropTypes from 'prop-types'

import { VFText, VFButton, Shimmer, Icon } from '@vfgroup-oneplatform/foundation/Components'
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes'
import ContentManager from '@vfgroup-oneplatform/foundation/ContentManager'

import { getThemeImages } from '../../Themes'

import {
  loadingConfig,
  shimmerPlaceholderConfig,
  calendarLoadingConfig
} from './StoreCard.LoadingConfig'

import styles from './StoreCard.Styles'


const StoreCard = ({
  store,
  cardSize,
  onShowTimeSlotsPress,
  isLoading,
  showTimeSlotButton,
  withViewLocationButton,
  cardContainerStyle,
  onPress,
  style,
  calendar,
  calendarLoading
}) => {

  const theme = useTheme()

  const viewLocation = () => {
    const scheme = Platform.select({ android: 'geo:', ios: 'maps:' })
    const url = `${scheme}${store.address.latitude},${store.address.longitude}`

    Linking.openURL(url)
  }

  const themedImages = getThemeImages(theme.name)


  const getCalendarHeadline = () => {

    const keysArrays = Object.keys(calendar)

    const lengthOfArray = Object.keys(calendar).length
    const firstHeadline = ContentManager.translate(keysArrays?.[0])
    const secondHeadline = ContentManager.translate(keysArrays?.[lengthOfArray - 1])

    const headline = firstHeadline + ' - ' + secondHeadline

    return headline
  }

  const getCalendarSubtile = () => {
    const keysArrays = Object.keys(calendar)

    const subtitle = calendar[keysArrays?.[0]]

    return subtitle
  }



  return (
    <TouchableOpacity
      activeOpacity={0.8}
      style={[styles.container(cardSize), style]}
      onPress={() => { onPress && onPress() }}
    >
      <View style={[styles.card(theme), cardContainerStyle]}>
        {isLoading ? (
          <Shimmer
            config={loadingConfig(theme)}
            shimmerPlaceholderConfig={shimmerPlaceholderConfig}
          />
        ) : (
          <>
            <VFText
              type={'primary'}
              style={styles.name}
              i18nKey={store?.name || ""}
              numberOfLines={1}
            />
            <VFText
              type={'primary'}
              style={styles.address}
              i18nKey={store?.address?.name}
            />
            <View>
              {store.description ? (
                <VFText
                  numberOfLines={1}
                  style={styles.additionalInfo(theme)}
                  i18nKey={store.description}
                />
              ) : null}
              {withViewLocationButton ? (
                <TouchableOpacity
                  style={[styles.row, { marginTop: 20 }]}
                  onPress={viewLocation}
                >
                  <Icon name={themedImages.icLocationRed} size={25} resizeMode='contain' />
                  <VFText
                    numberOfLines={1}
                    style={styles.locationText(theme)}
                    i18nKey="book_appointment_view_location"
                  />
                </TouchableOpacity>
              ) : null}
            </View>
            <View style={styles.separator(theme)} />
            <View style={styles.row}>
              <View style={styles.point} />
              <VFText
                i18nKey="book_appointment_timeslots_available"
                style={[styles.timeslotText(theme), { marginLeft: 8 }]}
              />
            </View>
            {calendarLoading && <View style={styles.calendarContainer}>
              <Shimmer
                config={calendarLoadingConfig}
                shimmerPlaceholderConfig={shimmerPlaceholderConfig}
              />
            </View>}
            {calendar && Object.keys(calendar)?.length > 0 && <View style={styles.calendarContainer}>
              <VFText i18nKey={getCalendarHeadline()} style={styles.calendarText(theme)} />
              <VFText i18nKey={getCalendarSubtile()} style={styles.calendarText(theme)} />
            </View>}
            {showTimeSlotButton && <VFButton
              onPress={onShowTimeSlotsPress}
              style={styles.button}
              title={'book_appointment_store_cta_button_title'}
            />}
          </>
        )}
      </View>
    </TouchableOpacity >
  )
}
StoreCard.defaultProps = {
  showTimeSlotButton: true,
  withViewLocationButton: false,
  calendar: null
}

StoreCard.propTypes = {
  store: PropTypes.object,
  cardSize: PropTypes.number,
  onShowTimeSlotsPress: PropTypes.func,
  isLoading: PropTypes.bool,
  showTimeSlotButton: PropTypes.string,
  withViewLocationButton: PropTypes.bool,
  style: PropTypes.object,
  calendar: PropTypes.object
}

export default StoreCard
